module.exports = __webpack_public_path__ + "static/icon-83544f0e62a3618f91b9465b57bee217.png";